import * as React from 'react';
import { Link,useLocation  } from 'react-router-dom';
import { AdviceIcon, HomeIcon, MyHealthIcon, SelectedAdviceIcon, SelectedHomeIcon, SelectedMyHealthIcon, SelectedSettingsIcon, SettingsIcon } from '../../shared/svgIcon';
export default function Tabmenu() {
  const location = useLocation();
  return (
    <>
      <div className="bg-white h-16 fixed bottom-0 z-50  max-w  grid grid-cols-4 gap-2 w-full text-xs ">
        <Link to="/Dashboard"  className='text-center rounded-3xl hover:bg-blue-200 m-1 text-primary p-2 justify-self-center'>
        {location.pathname=="/Dashboard"?
          <SelectedHomeIcon width={30} height={30} className=''/>
          :
          <HomeIcon width={30} height={30}/>
          }
          Home
        </Link>
        <Link to="/myHealth"  className='text-center rounded-3xl hover:bg-blue-200 m-1 text-primary p-2 flex flex-col items-center'>
        {location.pathname=="/myHealth"?
          <SelectedMyHealthIcon width={30} height={30}/>
          :
          <MyHealthIcon width={30} height={30} />
          }
          My Health
        </Link>
        {location.pathname=="/appointment"?
        <Link to="/Dashboard"  className='text-center rounded-3xl hover:bg-blue-200 m-1 text-primary py-2 flex flex-col items-center'> 
      
          <SelectedAdviceIcon width={30} height={30}/> Appointment
        </Link>
          :
          <Link to="/appointment"  className='text-center rounded-3xl hover:bg-blue-200 m-1 text-primary py-2 flex flex-col items-center'> 
          <AdviceIcon width={30} height={30}/>
         
          {/* Ask Advice */}
          Appointment
        </Link>
         }
        <Link to="/Settings"  className='text-center rounded-3xl hover:bg-blue-200 m-1 text-primary p-2 flex flex-col items-center'>
        {location.pathname=="/Settings"?
         <SelectedSettingsIcon width={30} height={30}/>:
         <SettingsIcon width={30} height={30}/>
         
        }
          Settings 
        </Link>
      </div>
      <div className='h-16'></div>
      
    </>
  );
}